/**
 * Создает объект для верхнего баннера.
 * @param {object} params
 * @param {object} params.action
 * @param {string[]} params.hideOnRouteNames - На каких страницах скрывать баннер
 * @param {string} params.action.title - Текст кнопки действия
 * @param {'readyOrders'} action.type - Тип действия. В данный момент только 'readyOrders'
 * @param {number[]} action.orderIds – Для типа действия 'readyOrders'
 */
export const createTopBanner = ({ title, action, hideOnRouteNames }) => {
  return {
    title,
    action,
    hideOnRouteNames,
  }
}
